import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProductFeedSerializer } from "web/types/serializers";

type FeedGridState = {
    ui: {
        isFetching: boolean;
    };
    data: Pick<ProductFeedSerializer, "feed_items">;
};

function deduplicate(
    existingItems: FeedGridState["data"]["feed_items"],
    newItems: FeedGridState["data"]["feed_items"]
): FeedGridState["data"]["feed_items"] {
    const uids = existingItems.map(({ product_card: { uid } }) => uid);
    return newItems.filter(({ product_card: { uid } }) => !uids.includes(uid));
}

const feedGrid = createSlice({
    name: "feedGrid",
    initialState: {
        ui: {
            isFetching: false,
        },
        data: {
            feed_items: [],
        },
    } as FeedGridState,
    reducers: {
        setFeedItems(state, action: PayloadAction<FeedGridState["data"]["feed_items"]>): void {
            state.data.feed_items = action.payload;
        },

        appendFeedItems(state, action: PayloadAction<FeedGridState["data"]["feed_items"]>): void {
            state.data.feed_items = [
                ...state.data.feed_items,
                ...deduplicate(state.data.feed_items, action.payload),
            ];
        },

        prependFeedItems(state, action: PayloadAction<FeedGridState["data"]["feed_items"]>): void {
            state.data.feed_items = [
                ...deduplicate(state.data.feed_items, action.payload),
                ...state.data.feed_items,
            ];
        },

        setFeedIsFetching(state, action: PayloadAction<FeedGridState["ui"]["isFetching"]>): void {
            state.ui.isFetching = action.payload;
        },
    },
});

const { actions, reducer } = feedGrid;
export const { setFeedItems, appendFeedItems, setFeedIsFetching, prependFeedItems } = actions;
export default reducer;
